import React from 'react';
import styled from 'styled-components';
import theme from 'fe-appdir-lib-theme';
import PropTypes from 'prop-types';
import { connect } from 'fe-hoc-connect';
import {
  store,
  selectAppsSearchResults,
} from 'fe-appdir-data-app';
import Section from './Section';

const PROP_TYPES = {
  isVisible: PropTypes.bool.isRequired,
  appResults: PropTypes.arrayOf(PropTypes.object).isRequired,
  onResultClick: PropTypes.func,
  gaResultClickCallback: PropTypes.func,
};

export const NUMBER_OF_APP_RESULTS = 3;
export const NUMBER_OF_CATEGORY_RESULTS = 3;

const MobileResultsWrapper = styled.div`
  @media (max-width: ${theme.breakpointSm}) {
    overflow-y: auto;
  }
`;

const Results = styled.div`
  width: 100%;
  display: ${(p) => (p.isVisible ? 'block' : 'none')};
  background-color: ${theme.colorWhite};

  @media (min-width: ${theme.breakpointSm}) {
    position: absolute;
    left: 0;
    right: 0;
    margin-top: -4px;
    border: 1px solid ${theme.colorGrey80};
    border-top: none;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 8px 10px 2px rgba(0, 0, 0, 0.1);
  }
`;

export const StatelessSearchResults = ({
  appResults,
  isVisible,
  onResultClick,
  gaResultClickCallback,
}) => (
  <MobileResultsWrapper>
    <Results isVisible={isVisible}>
      <Section
        heading="Apps"
        results={appResults}
        onResultClick={onResultClick}
        gaResultClickCallback={gaResultClickCallback}
      />
    </Results>
  </MobileResultsWrapper>
);

StatelessSearchResults.propTypes = PROP_TYPES;
StatelessSearchResults.displayName = 'SearchResults';

const SearchResults = connect(
  store,
  (state) => {
    return {
      appResults: selectAppsSearchResults(state, NUMBER_OF_APP_RESULTS),
    };
  },
)(StatelessSearchResults);

export default SearchResults;
